import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Checkbox } from '@ui/components/Checkbox/checkbox';
import LinkComponent from '@ui/components/Link/Link.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({ accepted, lang, onClick }: IProps) => {
    const getWord = useDictionary();

    return (
        <Box className="privacy-policy">
            <Checkbox
                name="privacyPolicyAcceptance"
                status={accepted ? 'checked' : 'unchecked'}
                onClick={onClick}
            />
            <Typography className="privacy-policy__text">
                {`${getWord('privacyPolicyAcceptance')} `}
                <LinkComponent
                    href={'/public/pdf/Agreement.html'}
                    text="privacyPolicyAcceptance_1"
                    lang={lang}
                />
                <LinkComponent
                    href={'https://fmsvega.ru/content/pdpp.pdf'}
                    text="privacyPolicy_1"
                    lang={lang}
                />
            </Typography>
        </Box>
    );
};

const PrivacyPolicyComponent = React.memo(Component);

export default PrivacyPolicyComponent;
